import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/estados-de-pagos-externos/';

/**
 * GET  Estados de Pagos Externos
 * @returns {Promise<Array<object>>}
 */
export const getEstadosDePagosExternos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Estado de Pago Externo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadoDePagoExterno = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Estado de Pago Externo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadoDePagoExterno = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Estado de Pago Externo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadoDePagoExterno = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Estado de Pago Externo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadoDePagoExterno = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
